import { useTranslation } from 'next-i18next';
import { FC } from 'react';

interface IRecordingOrder {
  orderKey: string;
}

const recordingOrders: IRecordingOrder[] = [{ orderKey: 'garden-area' }, { orderKey: 'expositions-area' }];

export const RecordingOrder: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <p>{t('photo-video-recording.recording-order.heading')}</p>
      <ul className="space-y-4">
        {recordingOrders.map(({ orderKey }) => (
          <li key={orderKey}>
            <p>{t(`photo-video-recording.recording-order.${orderKey}`)}</p>
          </li>
        ))}
      </ul>
    </>
  );
};
